import React, {useEffect, useState} from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import {BASE_URL} from '../config';

function LocationList() {
    const [locations, setLocations] = useState([]);
    const [editLocation, setEditLocation] = useState(null);
    const [showAddModal, setShowAddModal] = useState(false);
    const [newLocationName, setNewLocationName] = useState('');

    useEffect(() => {
        async function fetchLocations() {
            const response = await fetch(`${BASE_URL}/api/locations`);
            const data = await response.json();
            setLocations(data);
        }

        fetchLocations();
    }, []);

    const openEditModal = (location) => setEditLocation(location);

    const editLocationName = async (id, newName) => {
        const response = await fetch(`${BASE_URL}/api/locations/${id}/edit`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ name: newName }),
        });

        if (response.ok) {
            setLocations(prev => prev.map(
                loc => loc.location_id === id ? { ...loc, name: newName } : loc
            ));
            setEditLocation(null);
        } else {
            alert('Error editing location');
        }
    };

    const deleteLocation = async (id) => {
        const response = await fetch(`${BASE_URL}/api/locations/${id}/delete`, {method: 'DELETE'});
        if (response.ok) {
            setLocations(prev => prev.filter(location => location.location_id !== id));
        } else {
            alert('Error deleting location');
        }
    };

    const addNewLocation = async () => {
        const response = await fetch(`${BASE_URL}/api/locations/add`, {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({name: newLocationName}),
        });

        if (response.ok) {
            const locationsResponse = await fetch(`${BASE_URL}/api/locations`);
            const updatedLocations = await locationsResponse.json();
            setLocations(updatedLocations);
            setNewLocationName('');
            setShowAddModal(false);
        } else {
            alert('Error adding new location');
        }
    };

    return (
        <div className="container-fluid px-4 pt-3">
            <div className="d-flex align-items-start gap-3 mb-4">
                <h2 className="mb-0 mt-2">Lista lokalizacji</h2>
                <Button variant="success" className="mt-2" onClick={() => setShowAddModal(true)}>
                    Dodaj nową lokalizację
                </Button>
            </div>
            <table className="table table-striped table-hover">
                <thead>
                    <tr>
                        <th>Nazwa lokalizacji</th>
                        <th>Liczba produktów</th>
                        <th>Akcje</th>
                    </tr>
                </thead>
                <tbody>
                    {locations.map(location => (
                        <tr key={location.location_id}>
                            <td>{location.name}</td>
                            <td>{location.produkt_count}</td>
                            <td>
                                <Button variant="outline-primary" size="sm" onClick={() => openEditModal(location)}>
                                    Edytuj
                                </Button>
                                <Button variant="outline-danger" size="sm" onClick={() => deleteLocation(location.location_id)}>
                                    Usuń
                                </Button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            
            {editLocation && (
                <Modal show={Boolean(editLocation)} onHide={() => setEditLocation(null)}>
                    <Modal.Header closeButton>
                        <Modal.Title>Edytuj nazwę lokalizacji</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <form onSubmit={(e) => {
                            e.preventDefault();
                            const newName = e.target.elements.newName.value;
                            editLocationName(editLocation.location_id, newName);
                        }}>
                            <div className="mb-3">
                                <label htmlFor="newName" className="form-label">Nowa nazwa</label>
                                <input type="text" className="form-control" id="newName" defaultValue={editLocation.name} required />
                            </div>
                            <Button variant="primary" type="submit">Zapisz zmiany</Button>
                        </form>
                    </Modal.Body>
                </Modal>
            )}

            <Modal show={showAddModal} onHide={() => setShowAddModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Dodaj nową lokalizację</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={(e) => {
                        e.preventDefault();
                        addNewLocation();
                    }}>
                        <div className="mb-3">
                            <label htmlFor="newLocationName" className="form-label">Nazwa lokalizacji</label>
                            <input
                                type="text"
                                className="form-control"
                                id="newLocationName"
                                value={newLocationName}
                                onChange={(e) => setNewLocationName(e.target.value)}
                                required
                            />
                        </div>
                        <Button variant="primary" type="submit">Dodaj</Button>
                    </form>
                </Modal.Body>
            </Modal>
        </div>
    );
}

export default LocationList;
